module.exports = __webpack_public_path__ + "img/uj-investment-returns4@2x.eaf9f22.png";


//////////////////
// WEBPACK FOOTER
// ../website_20/static/img/UJ/uj-investment-returns4@2x.png
// module id = jRdz
// module chunks = 0